import { render, staticRenderFns } from "./Click2PayModal.vue?vue&type=template&id=0de74849&scoped=true"
import script from "./Click2PayModal.vue?vue&type=script&lang=js"
export * from "./Click2PayModal.vue?vue&type=script&lang=js"
import style0 from "./Click2PayModal.vue?vue&type=style&index=0&id=0de74849&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de74849",
  null
  
)

export default component.exports